import { render, staticRenderFns } from "./card-convites-diagnostico.vue?vue&type=template&id=5138635a&scoped=true"
import script from "./card-convites-diagnostico.vue?vue&type=script&lang=ts"
export * from "./card-convites-diagnostico.vue?vue&type=script&lang=ts"
import style0 from "./card-convites-diagnostico.vue?vue&type=style&index=0&id=5138635a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5138635a",
  null
  
)

export default component.exports